import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Unlock",
  "use": "icon-Unlock-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-Unlock\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.333 5a3.667 3.667 0 0 1 7.334 0v1.667H13a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h1.333V5Zm5.334 0v1.667H6.333V5a1.667 1.667 0 0 1 3.334 0ZM8 12a1.333 1.333 0 1 0 0-2.667A1.333 1.333 0 0 0 8 12Z\" fill=\"#A4B4D0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol